import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainerAtencao, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onClickGerar: () => void;
  onClickPular: () => void;
}

export function ModalPularGerarProcessoDigital({
  show,
  handleClose,
  onClickGerar,
  onClickPular,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={"Atenção"}
      centered
    >
      <InfoContainer>
        <IconeContainerAtencao>
          <FaExclamation />
        </IconeContainerAtencao>
        <TextContainer>Deseja gerar o PDF ou pular esta etapa?</TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "14rem" }}
          onClick={onClickGerar}
        >
          Gerar PDF
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "10rem" }}
          onClick={onClickPular}
          outline
          variante="primary"
        >
          Pular
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
